import { render, staticRenderFns } from "./manuFacturer.vue?vue&type=template&id=dcc0847a&scoped=true"
import script from "./manuFacturer.vue?vue&type=script&lang=js"
export * from "./manuFacturer.vue?vue&type=script&lang=js"
import style0 from "./manuFacturer.vue?vue&type=style&index=0&id=dcc0847a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc0847a",
  null
  
)

export default component.exports